// useEvents.ts
import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';

type WindowOption = '24h' | '48h' | '72h' | '7d';

export type EventRow = {
    id: number;
    event_title: string;
    event_summary: string;
    event_start: string;
    event_end: string | null;
    all_day: boolean;
    latitude: number;
    longitude: number;
    city: string | null;
    state: string | null;
    specific_place: string | null;
    rss_link: string | null;
};

function getWindowMs(win: WindowOption): number {
    switch (win) {
        case '24h': return 24 * 60 * 60 * 1000;
        case '48h': return 48 * 60 * 60 * 1000;
        case '7d':  return 7 * 24 * 60 * 60 * 1000;
        case '72h':
        default:    return 72 * 60 * 60 * 1000;
    }
}

export function useEvents(windowSize: WindowOption) {
    const [events, setEvents] = useState<EventRow[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        let cancelled = false;

        async function load() {
            setLoading(true);
            setError(null);

            const now = new Date();
            const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);
            const end = new Date(now.getTime() + getWindowMs(windowSize));

            const { data, error } = await supabase
                .from('public_safety_events')
                .select('*')
                //.not('latitude', 'is', null)
                //.not('longitude', 'is', null)
                .gte('event_start', yesterday.toISOString())
                .lt('event_start', end.toISOString())
                .order('event_start', { ascending: true });

            if (cancelled) return;

            if (error) {
                setError(error);
                setEvents([]);
            } else {
                setEvents((data || []) as EventRow[]);
            }

            setLoading(false);
        }

        load();
        const id = setInterval(load, 30000); // refresh every 30s

        return () => {
            cancelled = true;
            clearInterval(id);
        };
    }, [windowSize]);

    return { events, loading, error };
}
